import { render, staticRenderFns } from "./AtividadesClientes.vue?vue&type=template&id=2ad816ca"
import script from "./AtividadesClientes.vue?vue&type=script&lang=js"
export * from "./AtividadesClientes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports